import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import {
  Btn,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
  CustomCard,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import usePosicoesAssociadas, { LOAD_MESSAGE } from './PosicoesAssociadasHook'
import ModalPosicoesAssociadas from './ModalPosicoesAssociadas/ModalPosicoesAssociadas'
import { getPermissions } from '../../../../../services/localstorage/localstorage.service'

function PosicoesAssociadas({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = usePosicoesAssociadas()

  const { selectedInventario } = history.location.state

  const hasPermissaoZerarPosicoes = getPermissions().includes(50)

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesToAssoc(selectedTp, selectedInventario.inventario_id)
        break

      case LOAD_MESSAGE.DESASSOC_POS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.desassocPosicoesToInventario(
          selectedTp,
          selectedInventario.inventario_id,
          state.selectedPosicoes,
        )
        break

      case LOAD_MESSAGE.CREATE_CONF:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.createConferenciaFromPosicoes(
          selectedTp,
          selectedInventario.inventario_id,
          state.selectedPosicoes,
        )
        break

      case LOAD_MESSAGE.FINALIZAR_CONF:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.finalizarConferenciaDaPosicao(
          selectedTp,
          selectedInventario.inventario_id,
          state.selectedPosicao.id,
        )
        break

      case LOAD_MESSAGE.ZERAR_POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.zerarPosicoesRestantes(selectedTp, selectedInventario.inventario_id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedInventario: state.selectedInventario })
    }
  }, [state.pathToRedirect])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  return (
    <div>
      <PageHeader>
        <span>
          8.9 - Inventario <b>{selectedInventario.inventory_name}</b> - Posições Associadas
        </span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div className="p-col-12">
                <div className="p-grid">
                  <div className="p-col-4">
                    <CustomCard
                      title="Qte Posições Conferidas"
                      subTitle="Quantidade total de posições conferidas"
                      valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
                    >
                      {state.totalConferido}
                    </CustomCard>
                  </div>

                  <div className="p-col-4">
                    <CustomCard
                      title="Qte Posições Não Conferidas"
                      subTitle="Quantidade total de posições não conferidas"
                      valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
                    >
                      {state.totalNaoConferido}
                    </CustomCard>
                  </div>

                  <div className="p-col-4">
                    <CustomCard
                      title="Porcentagem Conferida"
                      subTitle="Porcentagem de posições conferidas"
                      valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
                    >
                      {state.percentage}%
                    </CustomCard>
                  </div>
                </div>
                <div style={{ marginTop: 15 }}>
                  <DataTable
                    header={
                      <>
                        <div
                          className="p-grid p-justify-center"
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <span style={{ display: 'inline-block' }}>
                            Estoque {selectedInventario.estoque}
                          </span>
                        </div>
                        <CustomDataTableHeader
                          onChange={value => localDispatch.onChange('globalFilter', value)}
                          value={state.globalFilter}
                          children={
                            <div style={{ display: 'inline-flex', marginLeft: 25, columnGap: 5 }}>
                              <Btn
                                onClick={() =>
                                  localDispatch.onClickDesassocPos(state.selectedPosicoes)
                                }
                              >
                                Desassociar
                              </Btn>
                              <Btn
                                onClick={() =>
                                  localDispatch.onClickCreateConferencia(state.selectedPosicoes)
                                }
                              >
                                Gerar Conferencia
                              </Btn>
                              <Btn onClick={() => localDispatch.onClickAnalise(selectedInventario)}>
                                Analise de Resultado
                              </Btn>
                              {hasPermissaoZerarPosicoes && (
                                <Btn onClick={() => localDispatch.onClickZerarPosicoes()}>
                                  Zerar posições restantes
                                </Btn>
                              )}
                            </div>
                          }
                        />
                      </>
                    }
                    globalFilter={state.globalFilter}
                    value={state.posicoes}
                    onSelectionChange={e => localDispatch.onChange('selectedPosicoes', e.value)}
                    selection={state.selectedPosicoes}
                    emptyMessage="Não existem posições para associação"
                  >
                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                    <Column field="sequencia" header="Sequencia" style={tableCellCentered()} />
                    <Column field="endereco" header="Posição" />
                    <Column field="status" header="Status" style={tableCellCentered(140)} />
                    <Column
                      header="Menu"
                      style={tableCellCentered(70)}
                      body={pick => (
                        <ThreeDots
                          items={localDispatch.getMenuItems()}
                          onClick={item => localDispatch.onMenuItemClicked(item, pick, selectedTp)}
                        />
                      )}
                      bodyStyle={tableCellCentered()}
                    />
                  </DataTable>
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
      <ModalPosicoesAssociadas
        isVisible={state.modal.show}
        mode={state.modal.mode}
        inventarioId={selectedInventario.inventario_id}
        selectedPosicao={state.modal.data}
        onClose={localDispatch.onClose}
      />
      <ConfirmDialog
        title="Zerar posições restantes"
        isVisible={state.confirmZerarPosicoes.show}
        content="Você tem certeza que deseja atribuir a quantidade zero para todas as posições com status Em Conferência? Essa operação NÃO poderá ser desfeita"
        onOk={localDispatch.onConfirmZerarPosicoes}
        onCancelar={localDispatch.onCancelZerarPosicoes}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(PosicoesAssociadas))
